import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Button from '@ajat/design-system/Button';

/* Top-left back buttons of a product page's gallery column — shared by the
 * photo Gallery, the 3D gallery and CreateSchool. Placement lives in
 * Gallery.css (.pp__back-desktop / .pp__back-mobile + per-layout overrides). */
const GalleryBack = () => (
  <>
    {/* Back — desktop */}
    <div className="pp__back-desktop">
      <Button
        size="tertiary"
        variant="gray"
        iconLeft={<ArrowLeft size={20} />}
        onClick={() => window.history.back()}
      />
    </div>

    {/* Back — mobile */}
    <div className="pp__back-mobile">
      <Button
        size="tertiary"
        variant="gray"
        iconOnly
        iconLeft={<ArrowLeft size={20} />}
        onClick={() => window.history.back()}
        aria-label="Tilbage"
      />
    </div>
  </>
);

export default GalleryBack;
